<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <SelectVue v-model="filters.lastName"
                   :options="newAndActiveUnemployedDropdown"
                   :is-clear="true"
                   :showMinCharsMessage="true"
                   :placeholder="$t('placeholder.last_name')"
                   :no-options-text="'Type to search...'"
                   @dropdown-fetch="(search) => handleDropdownSearch(search, 'lastName')"
                   @update:modelValue="(val) => onSelectValue(val, 'lastName')"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <SelectVue v-model="filters.insuranceNumber"
                   :options="insuranceNumberDropdown"
                   :is-clear="true"
                   :showMinCharsMessage="true"
                   :placeholder="'Versicherungsnr'"
                   @dropdown-fetch="(search) => handleDropdownSearch(search, 'insuranceNumber')"
                   @update:modelValue="(val) => onSelectValue(val, 'insuranceNumber')"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <SelectVue v-model="filters.aaNumber"
                   :options="aaNumberDropdown"
                   :is-clear="true"
                   :showMinCharsMessage="true"
                   :placeholder="'JC / AA Nummer'"
                   @dropdown-fetch="(search) => handleDropdownSearch(search, 'aaNumber')"
                   @update:modelValue="(val) => onSelectValue(val, 'aaNumber')"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="status && status.length">
          <SelectVue v-model="filters.status" :options="status" :is-clear="true"
                     :placeholder="$t('placeholder.status')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12" v-if="officeDropdown && officeDropdown.length">
        <SelectVue
            v-model="filters.locationId"
            :options="officeDropdown"
            :is-clear="true"
            :placeholder="'Standort'"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>

import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  newAndActiveUnemployedDropdown: {
    type: Array,
    required: true,
  },
  aaNumberDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  insuranceNumberDropdown: {
    type: Array,
    required: true,
  },
  status: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search, type) {
  emit('dropdown-fetch', search, type);
}

function onSelectValue(value, type) {
  if (!value) {
    emit('clear-dropdown', type);
  }
}

//const onUpdateLastName = (value) => {
//  filters.value.lastName = value ?? '';
//};
//
//const onUpdateInsuranceNumber = (value) => {
//  filters.value.insuranceNumber = value ?? '';
//};
//
//const onUpdateAANumber = (value) => {
//  filters.value.aaNumber = value ?? '';
//};
//
//const onUpdateStatus = (value) => {
//  filters.value.status = value ?? '';
//};
//
//const onUpdateLocationId = (value) => {
//  filters.value.locationId = value ?? '';
//};

</script>

<style scoped></style>